'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import type { ComponentProps, ReactNode } from 'react';
import { useCallback, useRef } from 'react';

interface CustomLinkProps
  extends Omit<ComponentProps<typeof Link>, 'prefetch'> {
  href: string;
  children: ReactNode;
}

export function CustomLink({ href, children, ...restProps }: CustomLinkProps) {
  const router = useRouter();
  const prefetchedRef = useRef(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const conditionalPrefetch = useCallback(() => {
    if (!prefetchedRef.current && href.startsWith('/')) {
      prefetchedRef.current = true;
      router.prefetch(href);
    }
  }, [href]);

  return (
    <Link
      href={href}
      {...restProps}
      prefetch={false}
      onMouseEnter={conditionalPrefetch}
      onPointerEnter={conditionalPrefetch}
      onTouchStart={conditionalPrefetch}
      onFocus={conditionalPrefetch}
    >
      {children}
    </Link>
  );
}
